import fontawesome from '@fortawesome/fontawesome';
import brands from '@fortawesome/fontawesome-free-brands';
import solid from '@fortawesome/fontawesome-free-solid';
import regular from '@fortawesome/fontawesome-free-regular';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VueMaskDirective } from 'v-mask';
import axios from 'axios';
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import BootstrapVue from 'bootstrap-vue';
import Notify from 'vue2-notify';
import 'bootstrap';

import './scss/style.scss';
import { VueNumericDirective } from './directives/VueNumericDirective';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.devtools = true;

Vue.config.productionTip = false;

fontawesome.library.add(solid, regular, brands);

Vue.use(Vuelidate);
Vue.use(Notify, { visibility: 10000, closeButtonClass: 'close', position: 'top-right' });
// TODO: I don't think this is used at all...
Vue.use(BootstrapVue);
Vue.directive('mask', VueMaskDirective);
Vue.directive('numeric', VueNumericDirective);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// eslint-disable-next-line import/prefer-default-export
export const axiosInstance = axios.create({
  baseURL: '/DesWebPortal',
});

Vue.prototype.$http = axiosInstance;

const vm = new Vue({
  router,
  store,
  render: h => h(App),
});
vm.$mount('#app');

export const VueInstance = vm;
